module.exports = __webpack_public_path__ + "static/media/attendSalesUp2.0a89a356.svg";